<template>
  <!-- 弹框 -->
  <Modal
    v-model="editListModal"
    width="700"
    title="充值"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
  <Form
    ref="editListForm"
    label-position="right"
    :label-width="120"
    :rules="ruleValidate"
    :model="editListForm"
  >
    <div class="" style="padding: 0 0 0 60px;line-height:24px;">
      <p>发票抬头：中易服信息科技有限公司 </p>
      <p>纳税人识别号：</p>
      <p>开户行：XX银行 </p>
      <p>对公账号：622222222222</p>
      <p>注册地址：</p>
      <p>公司电话：</p>
      <p>收件人：</p>
      <p>手机号码：</p>
      <p>邮政编码：</p>
      <p>收件地址：</p>
    </div>
    <FormItem label="发票编号"
      prop="invoice_no"
      label-for="invoice_no"
    >
      <Input
        placeholder="请输入发票编号"
        element-id="invoice_no"
        v-model="editListForm.invoice_no"
      ></Input>
    </FormItem>
    <FormItem label="物流编号"
      prop="logistics_no"
      label-for="logistics_no"
    >
      <Input
        placeholder="请输入物流编号"
        element-id="logistics_no"
        v-model="editListForm.logistics_no"
      ></Input>
    </FormItem>
    <FormItem label="开票凭证图片"
      label-for="img_urls"
    >
    <UploadImg
      :defaultList="defaultImgList"
      @on-change="editListForm.img_urls = $event">
    </UploadImg>
    </FormItem>
</Form>
</Modal>
</template>

<script>
import UploadImg from '@/components/UploadImg'

export default {
  components: {
    UploadImg
  },
  props: {
    ApplyId: {
      type: Number,
      required: true
    },
    editModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      listLoading: false,
      loading: true,
      defaultImgList: [],
      editListModal: this.editModal,
      editListForm: {
        invoice_no: '',
        logistics_no: '',
        img_urls: []
      },
      ruleValidate: {
        invoice_no: [
          { required: true, message: '请输入发票编号', trigger: 'blur' }
        ],
        logistics_no: [
          { required: true, message: '请输入物流编号', trigger: 'blur' }
        ]
        // img_urls: [
        //   { required: true, message: '最少提交一张开票凭证图片', trigger: 'blur' }
        // ]
      }
    }
  },
  watch: {
    editModal (val) {
      this.editListModal = val
      if (val) {
        this.reload()
      }
    },
    editListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  },
  methods: {
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          for (let obj in this.editListForm) {
            if (obj === 'img_urls') {
              let arr = []
              this.editListForm[obj].forEach(val => {
                arr.push(val.url)
              })
              this.editListForm[obj] = arr
            }
          }
          let data = {
            id: this.ApplyId,
            ...this.editListForm
          }
          let url = '/balance/maid'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              this.$Message.success('充值成功')
              this.editListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.defaultImgList = []
      this.editListForm = {
        invoice_no: '',
        logistics_no: '',
        img_urls: []
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/rakeBackManage/ApplyBalance.vue